import { createStore } from 'vuex'
import {THEME, TonConnectUI} from '@tonconnect/ui';

export default createStore({
  state: {
    TonConnect: null,
    mode: 'mainnet',
    jettonMaster: 'EQClJXBsceGlL1cx8izzPBrZPVwZ0AJ4CAovvfC1vV51UcFN',
    lastBlock: 0,
    isConnected: false,
    user: {
      address: null,
      walletAddress: null,
      balance: 0
    },
    hideInt: false,
    forceRefreshKitties: false
  },
  getters: {
    getTonConnect: (state) => {
      return state.TonConnect;
    },
    getAdder: (state) => {
      return state.mode === 'testnet' ? 'testnet.' : '';
    },
    getMode: (state) => {
      return state.mode;
    },
    getConnectionStatus: (state) => {
      return state.isConnected;
    },
    getTonWeb: (state) => {
      return state.TonWeb;
    },
    getContract: (state) => {
      return state.contract;
    },
    getJettonMaster: (state) => {
      return state.jettonMaster;
    },
    getUserAddress: (state) => {
      return state.user.address;
    },
    getUserWalletAddress: (state) => {
      return state.user.walletAddress;
    },
    getUserWalletBalance: (state) => {
      return state.user.balance;
    },
  },
  mutations: {
    SET_TON_CONNECT(state, lang) {
      // eslint-disable-next-line
      state.TonConnect = new TonConnectUI({
        manifestUrl: 'https://wife.capital/tonconnect-manifest.json',
        buttonRootId: 'connect',
        language: lang,
        uiPreferences: {
            borderRadius: "none",
            theme: THEME.LIGHT,
         },
          actionsConfiguration: {
              skipRedirectToWallet: 'always'
          }
    }); 
    },
    CHANGE_LANG_TONCONNECT(state, lang) {
      localStorage.setItem("lang", lang)
      if(state.TonConnect != null) {
            state.TonConnect.uiOptions = {
              language: lang 
          }
      }
          
    },
    SET_CONNECTION_STATUS(state, value) {
      state.isConnected = value
    },
    SET_USER_ADDRESS(state, address) {
      state.user.address = address
    },
    SET_USER_WALLET_ADDRESS(state, address) {
      state.user.walletAddress = address
    },
    SET_USER_WALLET_BALANCE(state, balance) {
      state.user.balance = balance
    },
  },
  actions: {
    setTonConnect({ commit }, value) {
      commit("SET_TON_CONNECT", value);
    },
    changeLangTonConnect({ commit }, value) {
      commit("CHANGE_LANG_TONCONNECT", value);
    },
    setConnectionStatus({ commit }, value) {
      commit("SET_CONNECTION_STATUS", value);
    },
    setUserAddress({ commit }, address) {
      commit("SET_USER_ADDRESS", address);
    },
    setUserWalletAddress({ commit }, address) {
      commit("SET_USER_WALLET_ADDRESS", address);
    },
    setUserWalletBalance({ commit }, balance) {
      commit("SET_USER_WALLET_BALANCE", balance);
    },
  },
  modules: {
  }
})
